import { useState, useEffect } from 'react';
import { useCurrentUser } from '@/shared/hooks/useCurrentUser';
import { inventoryStockInService } from '../services/inventoryStockIn.service';
import type { InventoryStockInFormValues, InventoryStockInItem } from '../types/inventoryStockIn.types';

const defaultValues: InventoryStockInFormValues = {
  quantity: 0,
  unit_cost: 0,
  transaction_date: new Date().toISOString().split('T')[0],
  note: '',
};

export function useInventoryStockIn(id: string) {
  const { user } = useCurrentUser();
  const [item, setItem] = useState<InventoryStockInItem | null>(null);
  const [values, setValues] = useState<InventoryStockInFormValues>(defaultValues);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    async function init() {
      if (!id || !user.companyId) return;

      try {
        setIsLoading(true);
        const data = await inventoryStockInService.getStockInItem(id, user.companyId);
        setItem(data);
        setValues(prev => ({
          ...prev,
          warehouse_id: data.warehouse_id || '',
          storage_location: data.storage_location || '',
        }));
      } catch (error) {
        console.error('[useInventoryStockIn] init error:', error);
      } finally {
        setIsLoading(false);
      }
    }
    init();
  }, [id, user.companyId]);

  const submitStockIn = async () => {
    if (!user.companyId || !user.id || !item) return false;
    if (values.quantity <= 0) {
      alert('S lng nhp phi ln hn 0');
      return false;
    }

    setIsSaving(true);
    try {
      await inventoryStockInService.createStockIn({
        inventory_item_id: item.id,
        quantity: values.quantity,
        transaction_date: values.transaction_date,
        type: 'stock_in',
        note: values.note,
        company_id: user.companyId,
        created_by: user.id,
        warehouse_id: values.warehouse_id || null,
        storage_location: values.storage_location || null,
        unit_cost: values.unit_cost || 0,
      });
      return true;
    } catch (error) {
      console.error('[useInventoryStockIn] submitStockIn error:', error);
      alert('C li xy ra khiệnhp kho. Vui lng th li.');
      return false;
    } finally {
      setIsSaving(false);
    }
  };

  return {
    item,
    values,
    setValues,
    isLoading,
    isSaving,
    submitStockIn,
    newStock: item ? item.current_stock + (values.quantity || 0) : 0,
  };
}
